import { Grid, TextField, useTheme } from "@mui/material";
import React from "react";
import useStylesSearchTable from "../reusableComponents/SearchTableStyle";

export default function Input(props) {
  const theme = useTheme();
  const textColor = theme.palette.mode === 'dark' ? 'white' : 'black';

  // Define distinct colors for labels
  const labelColor = theme.palette.mode === 'dark' ? '#B0BEC5' : '#424242'; // Light Blue Grey for dark mode and Dark Grey for light mode

  const propsInput = {
    // grid style: SearchTableStyle.js
    backGroundColor: props.backGroundColor,
    color: props.color,
    width: props.width,
    marginLeft: props.marginLeft,
    height: props.height,
    label: 'bold'
  };

  const classes = useStylesSearchTable(propsInput);

  const {
    name,
    placeHolder,
    value,
    onChange,
    type,
    className,
    height,
    error = null,
    disabled,
    width,
    marginLeft,
    component12SansText,
    ...other
  } = props;

  return (
    <>
      {!props.component12SansText ? (
        <>
          <Grid
            item xs={12} sm={12} md={10} lg={10}
            sx={{
              display: { xs: "none", sm: "none", md: "block", lg: "block" },
            }}
          >
            <TextField
              variant="outlined"
              size="small"
              name={name}
              placeholder={placeHolder}
              autoComplete="new-password"
              value={value}
              onChange={onChange}
              type={type}
              margin="dense"
              {...other}
              className={classes.inputStyle}
              {...(error && { error: true, helperText: error })}
              inputProps={{
                style: {
                  fontSize: "12px",
                  marginBottom: "0px",
                  paddingBottom: "10px",
                  shrink: true,
                  color: textColor
                },
              }}
              InputLabelProps={{
                style: {
                  color: labelColor // Apply distinct label color based on the theme
                }
              }}
            />
          </Grid>
          <Grid
            item xs={12} sm={12} md={12} lg={12}
            sx={{
              display: { xs: "block", sm: "block", md: "none", lg: "none" },
            }}
          >
            <TextField
              variant="outlined"
              size="small"
              name={name}
              placeholder={placeHolder}
              label={placeHolder}
              value={value}
              autoComplete="new-password"
              onChange={onChange}
              type={type}
              margin="dense"
              {...other}
              className={classes.inputStyle}
              {...(error && { error: true, helperText: error })}
              inputProps={{
                style: {
                  fontSize: "12px",
                  marginBottom: "0px",
                  paddingBottom: "10px",
                  shrink: true,
                  color: textColor
                },
              }}
              InputLabelProps={{
                style: {
                  color: labelColor // Apply distinct label color based on the theme
                }
              }}
            />
          </Grid>
        </>
      ) : 
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          size="small"
          name={name}
          placeholder={placeHolder}
          autoComplete="new-password"
          value={value}
          onChange={onChange}
          type={type}
          margin="dense"
          disabled={disabled || false}
          {...other}
          className={classes.inputStyle}
          {...(error && { error: true, helperText: error })}
          inputProps={{
            style: {
              fontSize: "12px",
              marginBottom: "0px",
              paddingBottom: "10px",
              shrink: true,
              color: textColor
            },
          }}
          InputLabelProps={{
            style: {
              color: labelColor // Apply distinct label color based on the theme
            }
          }}
        />
      </Grid>
      }
    </>
  );
}